import PLAYER_SENTIMENT from '@/pages/home/assets/svg/studio//opinions/player-sentiment.svg';
import CREATOR_ACTIVITIES from '@/pages/home/assets/svg/studio//opinions/creator-activities.svg';
import SOCIAL_MEDIAL from '@/pages/home/assets/svg/studio//opinions/social-media.svg';
import OPINIONS from '@/pages/home/assets/svg/studio//opinions/opinions.svg';
import INFLUENCERS from '@/pages/home/assets/svg/studio//opinions/influencers.svg';
import COMMON from '@/pages/home/assets/svg/studio//opinions/common.svg';

export type IconKey = "Player Sentiment" | "Creator Activities" | "Social Media" | "Opinions" | "Influencers" | "Common";

export const iconMap: Record<IconKey, string> = {
  "Player Sentiment": PLAYER_SENTIMENT,
  "Creator Activities": CREATOR_ACTIVITIES,
  "Social Media": SOCIAL_MEDIAL,
  "Opinions": OPINIONS,
  "Influencers": INFLUENCERS,
  "Common": COMMON,
};